import { axiosBase, errorHandler } from "./axios";

const createCookieService = (payload: any) => {
    return axiosBase
        .post("api/v1/cookies/create-cookies/", payload)
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};
const getCookieService = (sessionId:string) => {
    return axiosBase
        .get(`api/v1/cookies/get-cookies/${sessionId}`,)
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};
const updateCookieService = ({id,body}:{id:string,body:any}) => {
    return axiosBase
        .put(`api/v1/cookies/update-cookies/${id}`, body)
        .then((res) => res.data)
        .catch((err) => errorHandler(err));
};

export const cookiesService = {
    createCookieService,
    getCookieService,
    updateCookieService,
};
